<template>
  <div class="container">
    <div class="container-content">
      <div class="container-content-left">
        <h1>{{ $t(title) }}</h1>
        <div class="introduce">
          <span class="color-9 mr2">
            {{
              $t('lang.external.fzsy.content.home.所属专业：') + professional[0]
            }}
          </span>
          <span class="color-9 mr2"
            >{{
              $t('lang.external.fzsy.content.home.对应专业：') + professional[1]
            }}
          </span>
          <span class="color-9">
            {{
              $t('lang.external.fzsy.content.home.负责人：') + $t(principal)
            }}</span
          >
        </div>
        <p>{{ $t(content) }}</p>
        <div class="start" @click="goPath('Experimentation')">
          {{ $t('lang.external.fzsy.content.home.开始实验') }}
        </div>
      </div>
      <div class="container-content-right">
        <div class="container-content-right-btns">
          <span
            :class="{ 'active-video': active === 0 }"
            @click="handleChange(0)"
          >
            {{ $t('lang.external.fzsy.content.home.项目简介视频') }}
          </span>
          <span
            :class="{ 'active-video': active === 1 }"
            @click="handleChange(1)"
          >
            {{ $t('lang.external.fzsy.content.home.项目引导视频') }}
          </span>
        </div>
        <div class="container-content-right-video">
          <video v-if="isPlay" :src="videoURL" autoplay controls></video>
          <div class="image" v-else>
            <img :src="serverURL + 'images/video@2x.jpg'" alt="" />
            <p>{{ $t(videos[active].title) }}</p>
            <div class="image-play">
              <img
                @click="handlePlay"
                :src="serverURL + 'images/bofang  @2x.png'"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-main">
      <div class="container-main-left">
        <Exp-communicate :expId="expId" />
        <evaluate :expId="expId" v-show="parseInt(is_commentV) === 1" />
      </div>
      <div class="container-main-right">
        <Exp-status :data="{ score, scoreNum, userNumber, expNum }" />
      </div>
    </div>
  </div>
</template>

<script>
import { expInfo } from '@/api/experiment/index'
import ExpCommunicate from '@/components/experiment/expCommunicate .vue'
import evaluate from '@/components/experiment/question/evaluate.vue'
import ExpStatus from '@/components/experiment/expStatus.vue'
import { formatLan } from '@/utils/lanFormat'

export default {
  name: 'experiment',
  provide: {
    expId: parseInt(window.localStorage.getItem('expId')),
  },
  components: { ExpCommunicate, ExpStatus, evaluate },
  props: [],
  data() {
    return {
      title: 'lang.external.fzsy.content.home.中华建筑文化海外传播虚拟仿真实验',
      professional: [
        this.$t('lang.external.fzsy.content.home.建筑类'),
        this.$t('lang.external.fzsy.content.home.建筑学'),
      ],
      principal: 'lang.external.fzsy.content.home.陈志宏',
      content:
        'lang.external.fzsy.content.home.本项目以闽南传统侨乡建筑的代表泉州天后宫为案例，对其妈祖信仰、建筑空间进行知识点传授，接着利用虚拟仿真技术具有的真实性、模拟性的特点，对营造技艺、修缮复原施工过程进行虚拟还原，让学生在虚拟的环境下进行技艺的学习，亲身体会修缮复原的操作。',
      score: 0,
      scoreNum: 0,
      userNumber: 0,
      expNum: 0,
      videoURL: '/video/xmjj.mp4',
      active: 0,
      isPlay: false,
      is_commentV: 0,
      videos: [
        {
          value: 0,
          title: 'lang.external.fzsy.content.home.项目简介',
          video: '/video/xmjj.mp4',
        },
        {
          value: 1,
          title: 'lang.external.fzsy.content.home.引导视频',
          video: '/video/ydsp.mp4',
        },
      ],
    }
  },
  watch: {},
  computed: {
    expId() {
      return parseInt(window.localStorage.getItem('expId'))
    },
    serverURL() {
      return this.publicData.serverUrl
    },
  },
  created() {
    this.getInfo()
  },
  mounted() {},
  methods: {
    handleChange(n) {
      this.isPlay = false
      this.videoURL = this.videos[n].video
      this.active = n
    },
    handlePlay() {
      this.isPlay = true
    },
    getInfo() {
      expInfo(this.expId).then((res) => {
        const {
          courseName,
          introduce,
          principal,
          scoreNum,
          score,
          userNumber,
          expNum,
          is_comment,
        } = res.data
        this.is_commentV = is_comment
        this.title = formatLan(courseName)
        this.content = formatLan(introduce)
        this.principal = formatLan(principal)
        this.scoreNum = scoreNum
        this.score = score
        this.userNumber = userNumber
        this.expNum = expNum
      })
    },
    goPath() {
      let token = window.localStorage.getItem('token')
      let path = token ? '/experimentation' : '/login'
      this.$router.push(path)
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  &-content {
    width: 100%;
    display: flex;
    color: #666666;
    &-left {
      width: 50%;
      padding-right: 30px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      h1 {
        color: #0c5893;
        font-size: 30px;
        margin-top: 0;
        margin-bottom: 45px;
        font-weight: bold;
      }
      .introduce {
        display: flex;
      }
      p {
        min-height: 8rem;
      }
      .mr2 {
        margin-right: 2rem;
      }
      .start {
        background-image: var(--start-bg);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        color: white;
        font-size: 24px;
        padding: 11px 29px 17px 29px;
        margin-top: 30px;
        cursor: pointer;
      }
    }
    &-right {
      width: 50%;
      padding-left: 30px;
      display: flex;
      flex-direction: column;
      &-btns {
        width: 100%;
        display: flex;
        justify-content: space-around;
        color: white;
        margin-bottom: 30px;
        span {
          background-image: var(--videobtn-bg);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          font-size: 16px;
          padding: 13px 25px;
          cursor: pointer;
        }
        .active-video {
          background-image: var(--videobtna-bg);
        }
      }
      &-video {
        position: relative;
        .image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          min-height: 282px;
          display: flex;
          justify-content: center;
          align-items: center;
          &:hover {
            p {
              opacity: 0;
            }
            .image-play {
              opacity: 1;
            }
          }
          &-play {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 75px;
            height: 75px;
            cursor: pointer;
            background: rgba(255, 255, 255, 0.85);
            border-radius: 50%;
            padding: 15px 15px 15px 25px;
            font-size: xx-large;
            opacity: 0;
            transition: all 0.5s;
          }
          p {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            font-size: xx-large;
            margin: 0;
            opacity: 1;
            transition: all 0.5s;
            text-shadow: 0 0 5px black;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      video,
      iframe {
        width: 100%;
        height: 100%;
        min-height: 282px;
      }
    }
  }
  &-main {
    width: 100%;
    padding-top: 60px;
    display: flex;
    &-left {
      width: 70%;
    }
    &-right {
      width: 30%;
      padding-left: 30px;
    }
  }
}
</style>